import React from 'react';
import { Dropdown, DropdownProps } from 'primereact/dropdown';
import { withFormikFormControl } from '../FormikFormControl';
import {addCollabOptions, collabOptions, wrapComponent} from "../utils";
import {FormPageFieldComponentDefaultProps} from "types/formPage";
import {SingleSelect} from './SingleSelect';

export const SingleCollab = (props:FormPageFieldComponentDefaultProps) => {
  const withOptions = addCollabOptions(props)
  console.log('SingleCollab After Options', withOptions)
  const comp = <SingleSelect {...withOptions}/>;
  return comp
};

export const SingleCollabFormik = withFormikFormControl()(SingleCollab);

export default SingleCollabFormik;
